<template>
    <ui-sidebar-float
        :load-text="loadText"
        :load="loading"
        name="users-teams-add"
        title="Adicionar Equipe"
        text="Preencha corretamente os dados da nova equipe."
    >
        <div class="sidebar-content">
            <form>
                <ui-input v-model="form.data.name" type="text" label="Nome:" size="md" required />

                <ui-upload-files
                    :id="'users-teams-image-upload' + componentID"
					:refer="'users-teams-image-upload' + componentID"
                    :set-docs="form.data.logo"
                    accept=".png,.jpg"
                    label="Imagem:"
                    size="md"
                    @change="fileUpload('logo')"
                />

                <template v-for="(field, id) in form.fields">
                    <ui-input
                        v-if="
                            field.type === 'text' ||
							field.type === 'date' ||
							field.type === 'textarea' ||
							field.type === 'tel'
                        "
                        :key="'dinamic-field-' + id"
                        v-model="form.fieldsModels[field.id]"
                        :type="field.type"
                        :label="field.name"
                        size="md"
                    />

                    <ui-select-2
                        v-if="field.type === 'select'"
                        :key="'dinamic-select-field' + id"
                        v-model="form.fieldsModels[field.id]"
                        :data="field.options.options"
                        :label="field.name"
                        :multiple="field.options.multiple"
                        :search="field.options.search"
                    />
                </template>
            </form>

            <ui-overlay-load v-if="load" />
        </div>
        <template #footer>
            <ui-button
                type="button"
                design="lg success block"
                :disabled="!form.data.name"
                @click="submit"
            >
                Adicionar Equipe
            </ui-button>
        </template>
    </ui-sidebar-float>
</template>

<script>
	import { uiSidebarFloat, uiUploadFiles, uiOverlayLoad } from '@/components/ui'
	import { uiSelectTags, uiInput, uiSelect2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { team, fieldGroupHasField } from '@/services/axios'

	export default {
		components: {
			uiSidebarFloat,
			uiUploadFiles,
			uiSelectTags,
			uiButton,
			uiInput,
			uiSelect2,
			uiOverlayLoad,
		},

		data() {
			return {
				load: false,
				componentID: this._uid,
				form: {
					data: {
						name: null,
						logo: null,
					},
					fields: [],
					fieldsModels: [],
				},

				formData: null,
				loadText: null,
				loading: false
			}
		},

		computed: {},

		mounted() {
    		this.$root.$on('sidebar-open-users-teams-add', this.handleSidebarOpen);
		},

		beforeDestroy() {
			this.$root.$off('sidebar-close-users-teams-add', this.clearForm);
		},

		methods: {
			fileUpload(name) {
				const element = document.getElementById(
					'users-teams-image-upload' + this.componentID,
				)
				const file = element.files[0]

				this.formData = new FormData()

				this.formData.append(name, file)

				let reader = new FileReader()
                    this.form.data.logo = {base64: '', name: '', id: ''}
                    reader.addEventListener('load', () => {
                        this.form.data.logo['base64'] = reader.result
				})
				reader.readAsDataURL(file) 
					this.form.data.logo['name'] = file.name
					this.form.data.logo['id'] = 'users-teams-image-upload' + this.componentID
				this.$root.$emit('cancel-load-doc', this.form.data.logo['id'])
			},
			submit() {
				this.loadText = 'Criando a equipe'
				this.loading = true
				if (!this.form.data.name) return

				if (!this.formData) {
					this.formData = new FormData()
				}

				this.formData.append('name', this.form.data.name)

				if (this.form.fieldsModels) {
					Object.keys(this.form.fieldsModels).map((e) => {
						this.formData.append(`field_value[${e}]`, this.form.fieldsModels[e])
					})
				}	
				team.create('', this.formData)
					.then((response) => {
						if (response.data && response.data.status !== 'error') {
							if (response.data.msg) this.$toastr.s(response.data.msg)

							this.clearForm();

							this.formData = null

							this.$root.$emit('sidebar-close-users-teams-add')
							this.$root.$emit('users-teams-search')
						} else {
							if (response.data && response.data.msg)
								this.$toastr.e(response.data.msg)
						}
						this.loading = false
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
			},

			getFields() {
				this.load = true
				this.form.fields = []
				this.form.fieldsModels = []

				fieldGroupHasField
					.getTeamFields()
					.then((response) => {
						if (response.data && response.data.status !== 'error') {
							this.form.fields = response.data
						} else {
							if (response.data && response.data.msg)
								this.$toastr.e(response.data.msg)
						}
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.load = false
					})
			},
			clearForm() {
				this.form.data = {
					name: null,
					logo: null,
				}
				this.form.fieldsModels = []
     			this.$root.$emit('clean-file-doc')
    		},
			handleSidebarOpen() {
				this.getFields();
				this.clearForm();
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
